import { useQuery } from '@tanstack/react-query';
import { getApiClient } from '../api/apiClient';

const apiClient = getApiClient('kisanVani');

export const PENDING_POSTS_QUERY_KEY = ['pending-posts'];
const POLL_INTERVAL_MS = 30 * 1000;

/**
 * Newest posts waiting for moderation. A user's new post is created as "pending", so polling this
 * is how the admin dashboard learns that someone has just posted.
 */
export function usePendingPosts({ enabled = true, intervalMs = POLL_INTERVAL_MS } = {}) {
  return useQuery({
    queryKey: PENDING_POSTS_QUERY_KEY,
    queryFn: async () => {
      const response = await apiClient.get('/posts/all?status=pending&page=1&limit=10');
      const payload = response.data?.data;
      if (!response.data?.success || !Array.isArray(payload?.items)) {
        throw new Error('Invalid data format received');
      }
      return { items: payload.items, totalCount: payload.totalCount ?? payload.items.length };
    },
    enabled,
    refetchInterval: intervalMs,
    refetchIntervalInBackground: true,
    staleTime: 10 * 1000,
  });
}
